import { createDomain, sample, attach } from 'effector'
import { FormValues } from '~/entities/africa/Driver'
import { driverModel } from '~/entities/common/Driver'
import { Driver } from '~/shared/api'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { isString } from '~/shared/lib/utils'
import { formButtonsModel } from '~/shared/ui/Form'

export const domain = createDomain('features.africa.driver.edit')

export const sendFormFx = attach({
  effect: driverModel.saveFx,
  source: driverModel.$id,
  mapParams: (values: FormValues, id) => {
    const { regionId, citizenship, drivingLicenseIssuingCountry, ...attr } =
      values
    const driver = new Driver({
      ...(isString(citizenship) && { citizenship }),
      ...(isString(drivingLicenseIssuingCountry) && {
        drivingLicenseIssuingCountry,
      }),
      ...attr,
    })
    driver.setApiId(id as string)

    if (isString(regionId)) driver.setRegion(regionId)

    return driver
  },
})
sample({
  clock: sendFormFx.doneData,
  fn() {
    return {
      messageI18n: 'alert.saved successfully' as const,
      variant: 'success' as const,
    }
  },
  target: [snackbarEnqueued, formButtonsModel.editingEnded],
})
sample({
  clock: sendFormFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})

export const formSubmitted = domain.createEvent<FormValues>()
sample({
  clock: formSubmitted,
  target: sendFormFx,
})
